@if (page != null) {
  <portal-pagination
    [initializeFromStorage]="datatablePage.tableWasDestroyed === false"
    [page]="page"
    [selected]="selectionCount"
    (onPageChanged)="onPageChanged($event)"
  ></portal-pagination>
}
